import { AbstractControl } from '@angular/forms';
import { debounceTime, startWith } from 'rxjs/operators';
import { Utilities } from '@core/helpers/utilities';

export function withInitialValueDebounced(control: AbstractControl, debounceMs = Utilities.LISTENERS_DEBOUNCE_TIME) {
    return (source$) => source$.pipe(startWith(control.value), debounceTime(debounceMs));
}
